import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiOauthService, ApiServiceOptions, ApiWpService, MareAuthService } from "@mare-common/ngx-mare-auth";
import { ErrorHandlerService, EventInteractionService } from "@mare-common/ngx-mare-common";
import { environment } from "src/environments/environment";
import { PlatformApiWpService } from "./platform-apiwp.service";
import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";
import { catchError, Observable, tap, throwError } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PlatformApiWPublicService extends PlatformApiWpService {
  token: any;
  test_token = '';

  constructor(
    http: HttpClient,
    errorHandler: ErrorHandlerService,
    sanitizer: DomSanitizer,
    eventInteractionService: EventInteractionService,
    authService: MareAuthService,
    public route: ActivatedRoute,
    // public routeSnapshot: ActivatedRouteSnapshot
  ) {
    super(http, errorHandler, sanitizer, authService, eventInteractionService);
    let url!: string;
    const env: any = environment;
    if (this.isCurrentUrlLocalhost() || (env.forceServiceEndpoint && env.forceServiceEndpoint === true)) {
      url = environment.serviceEndpoint;
    } else {
      url = this.extractBaseUrl() + '/wp-json';
    }
    this.setEnvironment(url, undefined, undefined);
    this.getOrigin();

    this.token = route.snapshot.queryParams['token'] ?? this.test_token;
    // route.queryParams.subscribe(params => {
    //   this.token = params['token'] ?? this.test_token;
    // });
  }

  getToken() {
    return this.token;
  }

  override getRequest(endpoint: string, pars?: any, preventError?: boolean, preventLoader?: boolean, options?: ApiServiceOptions): Promise<Observable<any>> {
    if (this.token) {
      pars = pars ?? {};
      pars['token'] = this.token;
    }
    return super.getRequest(endpoint, {params: pars}, preventError, preventLoader, options);
  }

  override async postRequest(endpoint: string, body: any, pars?: any, preventError?: boolean, preventLoader?: boolean): Promise<Observable<any>> {
    const headers: any = await this.setHeaders();
    if (!preventLoader)
      this.showLoader();
    return this.http.post(this.buildUrl(this.getBaseUrl(), endpoint), body, { headers: headers, params: {'token': this.token} }).pipe(
      tap(() => {
        if (!preventLoader)
          this.hideLoader()
      }),
      catchError((err: any) => {
        if (!preventError)
          this.errorHandler.handleError(err);
        if (!preventLoader)
          this.hideLoader();
        return throwError(() => err);
      })
    );
  }


}
